/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Attributes_Clipboard_Missing_ErrorInputs */

const en_paste_attributes_clipboard_missing_error = /** @type {(inputs: Paste_Attributes_Clipboard_Missing_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clipboard does not contain Event Info`)
};

const fr_paste_attributes_clipboard_missing_error = /** @type {(inputs: Paste_Attributes_Clipboard_Missing_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le presse-papiers ne contient pas d'informations d'evenement`)
};

const de_paste_attributes_clipboard_missing_error = /** @type {(inputs: Paste_Attributes_Clipboard_Missing_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Zwischenablage enthält keine Ereignisinformationen`)
};

const it_paste_attributes_clipboard_missing_error = /** @type {(inputs: Paste_Attributes_Clipboard_Missing_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gli appunti non contengono informazioni sull'evento`)
};

const ru_paste_attributes_clipboard_missing_error = /** @type {(inputs: Paste_Attributes_Clipboard_Missing_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Буфер обмена не содержит информации о событии.`)
};

const es_paste_attributes_clipboard_missing_error = /** @type {(inputs: Paste_Attributes_Clipboard_Missing_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El portapapeles no contiene información del evento`)
};

const zh_cn2_paste_attributes_clipboard_missing_error = /** @type {(inputs: Paste_Attributes_Clipboard_Missing_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`剪贴板不包含事件信息`)
};

const ja_paste_attributes_clipboard_missing_error = /** @type {(inputs: Paste_Attributes_Clipboard_Missing_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリップボードにイベント情報が含まれていません`)
};

const hi_paste_attributes_clipboard_missing_error = /** @type {(inputs: Paste_Attributes_Clipboard_Missing_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्लिपबोर्ड में इवेंट की जानकारी नहीं है`)
};

const pt_pt2_paste_attributes_clipboard_missing_error = /** @type {(inputs: Paste_Attributes_Clipboard_Missing_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A área de transferência não contém informações sobre o evento.`)
};

/**
* | output |
* | --- |
* | "Clipboard does not contain Event Info" |
*
* @param {Paste_Attributes_Clipboard_Missing_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_attributes_clipboard_missing_error = /** @type {((inputs?: Paste_Attributes_Clipboard_Missing_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Attributes_Clipboard_Missing_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_paste_attributes_clipboard_missing_error(inputs)
	if (locale === "de") return de_paste_attributes_clipboard_missing_error(inputs)
	if (locale === "it") return it_paste_attributes_clipboard_missing_error(inputs)
	if (locale === "ru") return ru_paste_attributes_clipboard_missing_error(inputs)
	if (locale === "es") return es_paste_attributes_clipboard_missing_error(inputs)
	if (locale === "zh-CN") return zh_cn2_paste_attributes_clipboard_missing_error(inputs)
	if (locale === "ja") return ja_paste_attributes_clipboard_missing_error(inputs)
	if (locale === "hi") return hi_paste_attributes_clipboard_missing_error(inputs)
	if (locale === "pt-PT") return pt_pt2_paste_attributes_clipboard_missing_error(inputs)
	return en_paste_attributes_clipboard_missing_error(inputs)
});